// extracted by mini-css-extract-plugin
export var card = "_8n-1";
export var container = "_8n-0";